function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import PropTypes from 'prop-types';
import times from 'lodash/times';
import renderIf from '@signal/utils/renderIf';
import { Wrapper, SectionSkeleton, HeadingSkeleton, LabelSkeleton, MetricSkeleton } from './styles';
export var DataListSkeleton = function DataListSkeleton(props) {
  var items = props.items,
      showHeadingPlaceholder = props.showHeadingPlaceholder,
      typographyVariant = props.typographyVariant,
      sectionProps = props.sectionProps,
      rest = _objectWithoutProperties(props, ["items", "showHeadingPlaceholder", "typographyVariant", "sectionProps"]);

  return /*#__PURE__*/React.createElement(Wrapper, rest, times(items, function (i) {
    return /*#__PURE__*/React.createElement(SectionSkeleton, Object.assign({
      key: i
    }, sectionProps), /*#__PURE__*/React.createElement("div", null, renderIf(showHeadingPlaceholder, function () {
      return /*#__PURE__*/React.createElement(HeadingSkeleton, {
        width: 50
      });
    }), /*#__PURE__*/React.createElement(LabelSkeleton, {
      variant: typographyVariant,
      width: 150
    })), /*#__PURE__*/React.createElement(MetricSkeleton, {
      variant: typographyVariant,
      width: 35
    }));
  }));
};
DataListSkeleton.propTypes = {
  items: PropTypes.number
};
DataListSkeleton.defaultProps = {
  items: 3,
  typographyVariant: 'body2'
};
export default DataListSkeleton;